import { useTranslations } from 'next-intl';
import { Icon } from '../../Sprite';
import { GmBadge } from '../GmBadge';

interface Props {
  statusName?: string;
  className?: string;
}

// Shown on a locked reward: names the status that unlocks it, or "Coming soon" when none does yet.
export const GmLockedBadge = ({ statusName, className }: Props) => {
  const t = useTranslations('gamification');

  return (
    <GmBadge variant="glass" className={className}>
      <Icon name="block" className="size-2.5" />
      {statusName ? t('need-status', { status: statusName.toUpperCase() }) : t('coming-soon')}
    </GmBadge>
  );
};
